import { render, staticRenderFns } from "./InventoryHistoryGroup.vue?vue&type=template&id=2fe1be02&scoped=true&"
import script from "./InventoryHistoryGroup.vue?vue&type=script&lang=js&"
export * from "./InventoryHistoryGroup.vue?vue&type=script&lang=js&"
import style0 from "./InventoryHistoryGroup.vue?vue&type=style&index=0&id=2fe1be02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe1be02",
  null
  
)

export default component.exports